import React from 'react';
import PropTypes from 'prop-types';
import RenderLocalisationInputField from 'components/form/InputFields/RenderLocalisationInputField';
import SubmitButton from 'components/button/SubmitButton';
import compose from 'recompose/compose';
import { ButtonWrapper, FormWrapper, Item, Row, Section } from 'components/ui/table/elements';
import { connect } from 'react-redux';
import { reduxForm, isInvalid } from 'redux-form';

class PropertygroupsCreateForm extends React.Component {
    render() {
        const {
            form,
            handleSubmit,
            handleSubmitForm,
            invalid,
            localisationFields,
            pristine,
            submitting,
        } = this.props;

        return (
            <FormWrapper>
                <form onSubmit={ handleSubmit(handleSubmitForm) }>
                    <Section>
                        <Row>
                            <Item>
                                <RenderLocalisationInputField
                                    fields={ localisationFields }
                                    form={ form }
                                />
                            </Item>
                        </Row>
                    </Section>

                    <Section>
                        <Row>
                            <ButtonWrapper>
                                <SubmitButton
                                    disabled={ pristine || submitting || invalid }
                                    loading={ submitting }
                                />
                            </ButtonWrapper>
                        </Row>
                    </Section>
                </form>
            </FormWrapper>
        );
    }
}

PropertygroupsCreateForm.defaultProps = {
    localisationFields: [
        {
            maxLength: 255,
            name: 'name',
            required: true,
            type: 'text',
        },
    ],
};

PropertygroupsCreateForm.propTypes = {
    form: PropTypes.string,
    handleSubmit: PropTypes.func.isRequired,
    handleSubmitForm: PropTypes.func.isRequired,
    invalid: PropTypes.bool,
    localisationFields: PropTypes.array,
    pristine: PropTypes.bool,
    submitting: PropTypes.bool,
};

const mapStateToProps = (state, props) => {
    const {
        form,
    } = props;

    return {
        invalid: isInvalid(form)(state),
    };
};

const enhance = compose(
    connect(
        mapStateToProps,
        null,
    ),
    reduxForm(),
);

export default enhance(PropertygroupsCreateForm);



// WEBPACK FOOTER //
// ./src/pages/propertygroups/create/PropertygroupsCreateForm.js